import { render, staticRenderFns } from "./BSelectBox.vue?vue&type=template&id=1c2f412b&scoped=true&"
import script from "./BSelectBox.vue?vue&type=script&lang=js&"
export * from "./BSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./BSelectBox.vue?vue&type=style&index=0&id=1c2f412b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f412b",
  null
  
)

export default component.exports